import React, { useEffect, useState } from 'react'
import { connect } from "react-redux";
import moment from 'moment';

import { Menu, MenuItem, Fade } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import EditIcon from '@mui/icons-material/Edit';

import CustomTableV2 from '../../common/CustomTableV2';
import MuiModal from '../../common/muiModal'
import CustomSliderModal from '../../common/CustomSliderModal';
import AddAmbassadorModal from './components/AddAmbassadorModal';
import { GetAmbasadors } from "../../redux/ambassador/actions";

import "./style.css";
import EditAmbassador from './components/EditAmbassador';
import CustomSliderModalV2 from '../../common/CustomSliderModalV2';

function Ambassador(props) {

    // component states
    const [data, setData] = useState([])
    const [selected, setSelected] = useState(null)
    const [show, setShow] = useState(false)
    const [showType, setShowType] = useState(false)

    // menu states
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [currentIndex, setCurrentIndex] = useState('');
    const handleClick = (event, index) => {
        setCurrentIndex(index)
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className="main-container">
            <Fade in>
                <div>

                    <CustomTableV2
                        title="AMBASSADORS"
                        description="Control permission of ambassador users."
                        store={props.Ambassador}
                        table={{
                            headers: [
                                { title: "#" },
                                { title: "Last Name", value: "last_name", },
                                { title: "First Name", value: "first_name", },
                                { title: "Email Address", value: "email_address", },
                                { title: "DOB", },
                                { title: "" },
                            ],
                            body: (amb, i) => {
                                return (
                                    <tr className={i % 2 == 0 ? "tr-even" : ""}>
                                        <td><h5>{i}</h5></td>
                                        <td><h5>{amb.last_name?.toUpperCase()}</h5></td>
                                        <td><h5>{amb.first_name?.toUpperCase()}</h5></td>
                                        <td><h5>{amb.email_address}</h5></td>
                                        <td><h5>{amb?.dob ? moment(amb?.dob).format('MMM-DD-YYYY') : ''}</h5></td>
                                        <td>
                                            <h5>
                                                <MoreHorizIcon
                                                    id="basic-button"
                                                    onClick={(e) => handleClick(e, i)}
                                                    sx={{ fontSize: 40, cursor: 'pointer' }}
                                                />
                                                {i === currentIndex && (
                                                    <Menu
                                                        sx={{ zIndex: 800 }}
                                                        id="basic-menu"
                                                        anchorEl={anchorEl}
                                                        open={open}
                                                        onClose={handleClose}
                                                        MenuListProps={{
                                                            'aria-labelledby': 'basic-button',
                                                        }}
                                                    >
                                                        <MenuItem onClick={() => {
                                                            setShow(true);
                                                            setShowType("edit");
                                                            handleClose();
                                                            setSelected(amb);
                                                        }}><EditIcon sx={{ mr: '10px' }} /> Edit</MenuItem>
                                                    </Menu>
                                                )}
                                            </h5>
                                        </td>
                                    </tr>
                                )
                            }
                        }}
                        actions={{
                            get: (page, count, filter, sort) => {
                                props.GetAmbasadors(page, count, filter, sort);
                            },
                            add: () => {
                                setShow(true);
                                setShowType("add");
                            },
                        }}
                    />

                </div>
            </Fade>
            <CustomSliderModalV2 show={show} setShow={setShow} title={(showType && showType?.toUpperCase()) + " AMBASSADOR"}>
                {
                    showType == "add" &&
                    <AddAmbassadorModal data={data} setData={setData} setShow={setShow} />
                }

                {
                    showType == "edit" &&
                    <EditAmbassador user={selected} setShow={setShow} />
                }
            </CustomSliderModalV2>
        </div>
    );
}

const mapStateToProps = (state) => ({
    Ambassador: state.Ambassador
})

export default connect(mapStateToProps, {
    GetAmbasadors,
})(Ambassador);
